import React from 'react';
import { convertKilometersInUserUnit } from '../../../utils/unitHelper';
import { CircularProgress } from 'material-ui';
import Typography from '@material-ui/core/Typography';
import { FiZapOff } from 'react-icons/fi';

export class AverageDistanceText extends React.Component {
  render() {
    const { classes, t, averageDistance, loading, user } = this.props;
    // Radix with ParseInt(value, radix)
    let [distanceInUnit, unit] = convertKilometersInUserUnit(
      parseInt(averageDistance / 1000, 10),
      user
    );
    if (loading) {
      return <CircularProgress size={10} className={classes.buttonProgress} />;
    }

    if (isNaN(parseInt(averageDistance, 10))) {
      return (
        <Typography variant="body2" style={{ margin: 2, color: '#CECECE' }}>
          <FiZapOff style={{ position: 'relative', top: 3, marginRight: 10 }} />
          {t('No data yet')}
        </Typography>
      );
    }

    return (
      <Typography variant="h5" gutterBottom style={{ color: '#F87733' }}>
        {' '}
        {distanceInUnit} <span style={{ fontSize: '0.75rem' }}>{unit}</span>
      </Typography>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EquivalentToCards/AverageDistance/AverageDistanceText.js